module.exports = __webpack_public_path__ + "media/images/reg_1_redesign_ssn_shield-f028525c.png";